import { apiFetch } from '../../apiFetch'

export const getAdminTags = async (
  paginate = {
    page: 1,
    limit: 15
  }
) => {
  return await apiFetch({
    path: `/admin/tags?limit=${paginate.limit}&offset=${(parseInt(paginate.page) - 1) * parseInt(paginate.limit)}`
  })
}

export const getAdminTag = async (
  slug
) => {
  return await apiFetch({
    path: `/admin/tags/${slug}`
  })
}
